import React from "react";
import "./tabs.css";

/* This file renders the different tabs in the snapshots page
The tabs include All, In Progress and Submitted
 Depending on the state, the number of snapshots will change
*/
export default function SnapshotTabs({ toggleState, toggleTab }) {
  return (
    <div className="bloc-tabs-topic">
      <div className="bloc">
        <div
          className={
            toggleState === "All"
              ? "tabs-topic active-tabs-topic"
              : "tabs-topic"
          }
          onClick={() => {
            toggleTab("All");
          }}
        >
          <p>All</p>
        </div>
        <div
          className={
            toggleState === "In Progress"
              ? "tabs-topic active-tabs-topic"
              : "tabs-topic"
          }
          onClick={() => {
            toggleTab("In Progress");
          }}
        >
          <p>In Progress</p>
        </div>
        <div
          className={
            toggleState === "Submitted"
              ? "tabs-topic active-tabs-topic"
              : "tabs-topic"
          }
          onClick={() => {
            toggleTab("Submitted");
          }}
        >
          <p>Submitted</p>
        </div>
        <div
          className={
            toggleState === "Requested"
              ? "tabs-topic active-tabs-topic"
              : "tabs-topic"
          }
          onClick={() => {
            toggleTab("Requested");
          }}
        >
          <p>RepX Requests</p>
        </div>
        <div
          className={
            toggleState === "Generated"
              ? "tabs-topic active-tabs-topic"
              : "tabs-topic"
          }
          onClick={() => {
            toggleTab("Generated");
          }}
        >
          <p>RepX Reports</p>
        </div>
      </div>
    </div>
  );
}
